import DashboardLayout from "layout/DashboardLayout";
import ARCStatusPage from "pages/dashboard/ARCStatusPage";
import DataAnalysisPage from "pages/dashboard/DataAnalysisPage";
import AllFleetsPage from "pages/dashboard/AllFleetsPage";
import FleetMissionsPage from "pages/dashboard/FleetMissionsPage";
import SchedulesPage from "pages/dashboard/FleetSchedulesPage";
import { logRoutes } from "./log";

const dashboardTabItems = [
    /* {
        title: "Overview",
        to: "/dashboard",
    }, */
    // {
    // title: "ARC Status",
    // to: "/dashboard/arc-status",
    // },
    // {
    //     title: "Data Analysis",
    //     to: "/dashboard/data-analysis",
    // },
    /* {
        title: "Log History",
        to: "/dashboard/log/mission",
    }, */
];

export const dashboardRoutes = {
    path: "dashboard",
    element: <DashboardLayout title="Dashboard" tabs={dashboardTabItems} />,
    children: [
        {
            index: true,
            element: <AllFleetsPage />,
        },
        {
            path: "arc-status",
            element: <ARCStatusPage />,
        },
        {
            path: "data-analysis",
            element: <DataAnalysisPage />,
        },
        {
            path: "missions",
            element: <FleetMissionsPage />,
        },
        {
            path: "schedules",
            element: <SchedulesPage />,
        },
        logRoutes,
    ],
};
